<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Detalle del Movimiento
            </b-card-header>
            <b-card-body>
            <div class="col-md-12 text-center">             
                <div class="col-md-12">
                    <img :src="model.Image" style="width: 40px" alt />
                </div>
                <br>
                <div class="col-md-12">
                    <label>{{ model.ReceiptName }}</label>
                </div>
                <div class="col-md-12">
                    <label>{{ model.ReceiptDate }}</label>
                </div>
                <div class="col-md-12" style="color: #ff5855; font-weight: bolder">
                    <label>IMPUESTOS</label>
                </div> 
            </div>
            <br />

            <div class="row"
            v-for="item in model.impuestos"
            @click="itemClicked(item)"
            v-bind:key="item.EntityID"
            style=
              "padding: 5px;
              border-bottom: 1px solid #d6d4d4;
              cursor: pointer;
              margin-right: 0;
              margin-left: 0;">
            <div class="col-4" style="padding-top: 20px">
              {{ item.Description }}
            </div>
            <div class="col-8 text-right" style="padding-top: 10px">
              {{ item.FormattedAmount }}
            </div>
          </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import generalHelpers from "@/helpers/generalHelpers";

    export default {
        props: {
            mastercardMovementID: Number,
            image: String,
            receiptName: String,
            receiptDate: String
        },
        data(){
            return {
                model: {
                    MastercardMovementID: this.mastercardMovementID,
                    Image: this.image,
                    ReceiptName: this.receiptName,
                    ReceiptDate: this.receiptDate,
                    impuesto: [],
                    impuestos: {},
                }
            };
        },
        mounted() {
            let context = this;
            let req = { MastercarMovementID: context.model.MastercardMovementID };

            axiosHelpers.axiosPost('Mastercard/MastercardMovementTaxes', req, this, function(data){    
                    context.model.impuestos = data.ResponseVM.Items;
            });

            context.model.Image = generalHelpers.getLocalImage(context.model.Image);
        }
    }
</script>